(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,4006],{

/***/ 8929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__(894);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/components/Shared/Form.js
var Form = __webpack_require__(472);
// EXTERNAL MODULE: ./styles/contact.module.scss
var contact_module = __webpack_require__(451);
var contact_module_default = /*#__PURE__*/__webpack_require__.n(contact_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
;// CONCATENATED MODULE: ./src/components/Home/HeroSection/assets/next.svg
/* harmony default export */ var next = ({"src":"/_next/static/media/next.1b3eb015.svg","height":200,"width":200});
;// CONCATENATED MODULE: ./src/components/Home/HeroSection/assets/prev.svg
/* harmony default export */ var prev = ({"src":"/_next/static/media/prev.bc00226e.svg","height":200,"width":200});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Home/HeroSection/styles/style.module.scss
var style_module = __webpack_require__(6323);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/utils/whatsapp.mjs
var whatsapp = __webpack_require__(735);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Home/HeroSection/index.js















var Hero = function Hero(_ref) {
  var _heroData$items;

  var heroData = _ref.heroData,
      siteInfo = _ref.siteInfo;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var dir = (0,react.useMemo)(function () {
    return locale === "en" ? "ltr" : "rtl";
  }, [locale]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (style_module_default()).hero,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "swiper-button-next",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: prev,
        width: 50,
        height: 50,
        alt: "prev-icon"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "swiper-button-prev",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: next,
        width: 50,
        height: 50,
        alt: "next-icon"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
      slidesPerView: 1,
      modules: [swiper_esm/* Navigation */.W_, swiper_esm/* Pagination */.tl, swiper_esm/* Autoplay */.pt, swiper_esm/* EffectFade */.xW],
      dir: dir,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        clickable: true
      },
      children: heroData === null || heroData === void 0 ? void 0 : (_heroData$items = heroData.items) === null || _heroData$items === void 0 ? void 0 : _heroData$items.map(function (item, index) {
        var _item$heading, _item$boldHeading, _item$description;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "hero",
            style: {
              paddingInline: "35px"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "slider",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "hero-slider",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-lg-10 col-12 text-start wrapper w-100",
                  style: {
                    direction: locale === "ar" ? "rtl" : "ltr"
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "h-item",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        md: "6",
                        className: "h-item-div",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
                          className: "h1",
                          children: [item === null || item === void 0 ? void 0 : (_item$heading = item.heading) === null || _item$heading === void 0 ? void 0 : _item$heading[locale], /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                            children: item === null || item === void 0 ? void 0 : (_item$boldHeading = item.boldHeading) === null || _item$boldHeading === void 0 ? void 0 : _item$boldHeading[locale]
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          children: item === null || item === void 0 ? void 0 : (_item$description = item.description) === null || _item$description === void 0 ? void 0 : _item$description[locale]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "d-flex align-items-center gap-3",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                            href: "/personnel",
                            passHref: true,
                            className: "gradient-btn",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                              id: "recruitmentRequest"
                            })
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                            href: (0,whatsapp/* buildWhatsAppUrl */.H)(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.whatsup),
                            passHref: true,
                            className: "gradient-btn",
                            target: "_blank",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                              id: "transferMaidsRequest"
                            })
                          })]
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: "6",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
                          className: "hero-secondary-wrapper",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "hero-secondary",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                              loading: index === 0 ? "eager" : "lazy",
                              priority: index === 0,
                              src: item === null || item === void 0 ? void 0 : item.image,
                              width: 600,
                              height: 600,
                              style: {
                                minHeight: "150px"
                              },
                              alt: "Hero image"
                            })
                          })
                        })
                      })]
                    })
                  })
                })
              })
            })
          })
        }, index);
      })
    }, dir)]
  });
};

/* harmony default export */ var HeroSection = (Hero);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./src/components/handlers/index.js + 1 modules
var handlers = __webpack_require__(9400);
;// CONCATENATED MODULE: ./src/components/Home/About/index.js


 // Import dynamic for client-side rendering




 // Dynamically import ReactPlayer to avoid hydration issues



var ReactPlayer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2004).then(__webpack_require__.t.bind(__webpack_require__, 2004, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2004)];
    }
  }
});
function About(_ref) {
  var _data$subTitle, _data$subTitle$locale, _data$description, _data$description$loc;

  var data = _ref.data,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? "0" : _ref$page,
      siteInfo = _ref.siteInfo;

  var _useIntl = (0,useIntl/* default */.Z)(),
      locale = _useIntl.locale;

  var renderMedia = function renderMedia(media) {
    if (!media || media.trim() === "") return null; // Check for non-empty media strings

    var isPlayableMedia = function isPlayableMedia(url) {
      var playablePatterns = [/(?:https?:\/\/)?(?:www\.)?(youtube\.com|youtu\.be|vimeo\.com)/i // YouTube/Vimeo links
      ];
      return playablePatterns.some(function (pattern) {
        return pattern.test(url);
      });
    };

    if (isPlayableMedia(media)) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ReactPlayer, {
        url: media,
        controls: true,
        width: "100%",
        height: 400,
        style: {
          minHeight: "200px"
        },
        className: "video-player rounded-4 mb-3 overflow-hidden"
      });
    }

    if (media.match(/\.(mp4|webm|ogg)$/i)) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
        controls: true,
        width: "100%",
        height: "100%",
        className: "video-player rounded-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          src: (0,handlers/* handleImage */.M)(media),
          type: "video/mp4"
        }), "Your browser does not support the video tag."]
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "wrapper about w-100",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: "about-pic w-100 m-0 align-items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          xs: "12",
          md: "8",
          xl: "6",
          className: "px-0 img-wrapper m-auto",
          children: renderMedia((data === null || data === void 0 ? void 0 : data.image) || (data === null || data === void 0 ? void 0 : data.youtubeLink))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          xs: "12",
          md: "12",
          xl: "6",
          className: "align-self-center info p-lg-4",
          children: [(data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : (_data$subTitle$locale = _data$subTitle[locale]) === null || _data$subTitle$locale === void 0 ? void 0 : _data$subTitle$locale.trim()) && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "unique-bold text-start color-main h2",
            children: data.subTitle[locale]
          }), (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : (_data$description$loc = _data$description[locale]) === null || _data$description$loc === void 0 ? void 0 : _data$description$loc.trim()) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "pt-lg-4 pt-0",
            children: data.description[locale]
          }), page !== "about" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "rounded-5 whatsapp",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: (0,whatsapp/* buildWhatsAppUrl */.H)(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.whatsup),
              "aria-label": "whatsapp",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "send-whatsapp"
              })
            })
          })]
        })]
      })
    })
  });
}
// EXTERNAL MODULE: ./src/components/Home/Systems/index.module.scss
var index_module = __webpack_require__(7601);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/Home/Systems/index.js











function Systems(_ref) {
  var _data$items, _data$heading;

  var data = _ref.data,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? "" : _ref$page,
      siteInfo = _ref.siteInfo;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var renderSystems = data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(function (item, k) {
    var _item$heading, _item$description;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
      xs: "12",
      md: "6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: item.url || "",
        scroll: !!item.url,
        "aria-label": "system-link",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "system",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "img-wrapper m-auto",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: (0,handlers/* handleImage */.M)(item === null || item === void 0 ? void 0 : item.icon),
                width: 55,
                height: 55,
                alt: (item === null || item === void 0 ? void 0 : item.title) || "" // objectFit="contain"

              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "py-3 unique-bold",
              children: (_item$heading = item.heading) === null || _item$heading === void 0 ? void 0 : _item$heading[locale]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "py-3 p",
              dangerouslySetInnerHTML: {
                __html: (_item$description = item.description) === null || _item$description === void 0 ? void 0 : _item$description[locale]
              }
            })]
          })
        }, "service" + k)
      })
    }, k);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((index_module_default()).systems, " wrapper w-100"),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
      className: " ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " info",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "pb-1 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "section-tag text-dark m-auto",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "alnjoom-systems"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "pb-2 fw-bold",
          children: data === null || data === void 0 ? void 0 : (_data$heading = data.heading) === null || _data$heading === void 0 ? void 0 : _data$heading[locale]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        className: "systems-wrapper",
        children: renderSystems
      }), page != "systems" && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "rounded-5 whatsapp",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: (0,whatsapp/* buildWhatsAppUrl */.H)(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.whatsup),
            "aria-label": "whatsapp",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "send-whatsapp"
            })
          })
        })
      })]
    })
  });
}
// EXTERNAL MODULE: ./src/components/Home/Countries/index.js
var Countries = __webpack_require__(5424);
// EXTERNAL MODULE: ./src/components/Shared/Next-seo.js
var Next_seo = __webpack_require__(6543);
// EXTERNAL MODULE: ./src/components/Home/RequirementsSection/styles/style.module.scss
var styles_style_module = __webpack_require__(901);
var styles_style_module_default = /*#__PURE__*/__webpack_require__.n(styles_style_module);
;// CONCATENATED MODULE: ./src/components/Home/RequirementsSection/index.js











var RequirementsSection = function RequirementsSection(_ref) {
  var _data$heading, _data$subHeading, _data$papers, _data$papers2, _data$papers2$title, _data$papers3, _data$papers4, _data$papers4$descrip, _data$papers5, _data$papers5$items, _data$procedures, _data$procedures2, _data$procedures2$tit, _data$procedures3, _data$procedures4, _data$procedures4$des, _data$procedures5, _data$procedures5$ite;

  var data = _ref.data,
      siteInfo = _ref.siteInfo;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (styles_style_module_default()).requirements,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
      className: "d-flex flex-column align-items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "header-container d-flex flex-column align-items-center justify-content-center mb-3",
        children: [(data === null || data === void 0 ? void 0 : data.heading) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "h2 fw-bold",
          children: data === null || data === void 0 ? void 0 : (_data$heading = data.heading) === null || _data$heading === void 0 ? void 0 : _data$heading[locale]
        }), (data === null || data === void 0 ? void 0 : data.subHeading) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: data === null || data === void 0 ? void 0 : (_data$subHeading = data.subHeading) === null || _data$subHeading === void 0 ? void 0 : _data$subHeading[locale]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: "gy-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          lg: 6,
          md: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "items-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "items-header",
              children: [(data === null || data === void 0 ? void 0 : (_data$papers = data.papers) === null || _data$papers === void 0 ? void 0 : _data$papers.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "h4",
                children: data === null || data === void 0 ? void 0 : (_data$papers2 = data.papers) === null || _data$papers2 === void 0 ? void 0 : (_data$papers2$title = _data$papers2.title) === null || _data$papers2$title === void 0 ? void 0 : _data$papers2$title[locale]
              }), (data === null || data === void 0 ? void 0 : (_data$papers3 = data.papers) === null || _data$papers3 === void 0 ? void 0 : _data$papers3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "h5",
                children: data === null || data === void 0 ? void 0 : (_data$papers4 = data.papers) === null || _data$papers4 === void 0 ? void 0 : (_data$papers4$descrip = _data$papers4.description) === null || _data$papers4$descrip === void 0 ? void 0 : _data$papers4$descrip[locale]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "items",
              children: data === null || data === void 0 ? void 0 : (_data$papers5 = data.papers) === null || _data$papers5 === void 0 ? void 0 : (_data$papers5$items = _data$papers5.items) === null || _data$papers5$items === void 0 ? void 0 : _data$papers5$items.map(function (item, index) {
                var _item$text;

                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "item",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item === null || item === void 0 ? void 0 : item.icon,
                      width: 20,
                      height: 20,
                      alt: item === null || item === void 0 ? void 0 : item.text,
                      unoptimized: true
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: item === null || item === void 0 ? void 0 : (_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text[locale]
                  })]
                }, index);
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          lg: 6,
          md: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "items-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "items-header",
              children: [(data === null || data === void 0 ? void 0 : (_data$procedures = data.procedures) === null || _data$procedures === void 0 ? void 0 : _data$procedures.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "h4",
                children: data === null || data === void 0 ? void 0 : (_data$procedures2 = data.procedures) === null || _data$procedures2 === void 0 ? void 0 : (_data$procedures2$tit = _data$procedures2.title) === null || _data$procedures2$tit === void 0 ? void 0 : _data$procedures2$tit[locale]
              }), (data === null || data === void 0 ? void 0 : (_data$procedures3 = data.procedures) === null || _data$procedures3 === void 0 ? void 0 : _data$procedures3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "h5",
                children: data === null || data === void 0 ? void 0 : (_data$procedures4 = data.procedures) === null || _data$procedures4 === void 0 ? void 0 : (_data$procedures4$des = _data$procedures4.description) === null || _data$procedures4$des === void 0 ? void 0 : _data$procedures4$des[locale]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "items",
              children: data === null || data === void 0 ? void 0 : (_data$procedures5 = data.procedures) === null || _data$procedures5 === void 0 ? void 0 : (_data$procedures5$ite = _data$procedures5.items) === null || _data$procedures5$ite === void 0 ? void 0 : _data$procedures5$ite.map(function (item, index) {
                var _item$text2;

                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "item",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item === null || item === void 0 ? void 0 : item.icon,
                      width: 20,
                      height: 20,
                      alt: item === null || item === void 0 ? void 0 : item.text,
                      unoptimized: true
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: item === null || item === void 0 ? void 0 : (_item$text2 = item.text) === null || _item$text2 === void 0 ? void 0 : _item$text2[locale]
                  })]
                }, index);
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "rounded-5 whatsapp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: (0,whatsapp/* buildWhatsAppUrl */.H)(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.whatsup),
          "aria-label": "whatsapp",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "send-whatsapp"
          })
        })
      })]
    })
  });
};

/* harmony default export */ var Home_RequirementsSection = (RequirementsSection);
;// CONCATENATED MODULE: ./pages/index.js
















var Index = function Index(props) {
  var _seoData$title, _seoData$description, _seoData$keywords, _initData$siteInfo$ma, _initData$siteInfo;

  var heroData = props.heroData,
      systemsData = props.systemsData,
      aboutData = props.aboutData,
      countriesData = props.countriesData,
      personnelsData = props.personnelsData,
      requirementsData = props.requirementsData,
      siteInfo = props.siteInfo,
      initData = props.initData,
      seoData = props.seoData;

  var _useIntl = (0,useIntl/* default */.Z)(),
      locale = _useIntl.locale;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Next_seo["default"], {
      title: seoData === null || seoData === void 0 ? void 0 : (_seoData$title = seoData.title) === null || _seoData$title === void 0 ? void 0 : _seoData$title[locale],
      description: seoData === null || seoData === void 0 ? void 0 : (_seoData$description = seoData.description) === null || _seoData$description === void 0 ? void 0 : _seoData$description[locale],
      keywords: seoData === null || seoData === void 0 ? void 0 : (_seoData$keywords = seoData.keywords) === null || _seoData$keywords === void 0 ? void 0 : _seoData$keywords[locale]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "ld-json-organization",
      type: "application/ld+json",
      strategy: "afterInteractive",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [{
            "@type": "Organization",
            "@id": "https://alnjoom.sa/#organization",
            name: "مكتب النجوم المميزة للاستقدام في تبوك",
            alternateName: "Al Nojoom Al Mumayazah Recruitment Office",
            url: "https://alnjoom.sa/",
            logo: {
              "@type": "ImageObject",
              "@id": "https://alnjoom.sa/#logo",
              url: "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png",
              contentUrl: "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png",
              caption: "مكتب النجوم المميزة للاستقدام"
            },
            image: {
              "@type": "ImageObject",
              url: "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png"
            },
            telephone: "+966594003605",
            email: "ads@alnjoom.sa",
            foundingDate: "2010-01-01",
            address: {
              "@type": "PostalAddress",
              streetAddress: "King Fahd Rd, Assulimaniyah",
              addressLocality: "Tabuk",
              addressRegion: "Tabuk",
              postalCode: "47312",
              addressCountry: "SA"
            },
            contactPoint: {
              "@type": "ContactPoint",
              "@id": "https://alnjoom.sa/#contact",
              telephone: "+966594003605",
              contactType: "customer support",
              availableLanguage: ["Arabic", "English"],
              areaServed: "SA"
            },
            sameAs: ["https://twitter.com/alnjoom33", "https://www.tiktok.com/@alnjoom33", "https://snapchat.com/t/OqgbB9dG"]
          }, {
            "@type": "EmploymentAgency",
            "@id": "https://alnjoom.sa/#agency",
            name: "مكتب النجوم المميزة للاستقدام في تبوك",
            url: "https://alnjoom.sa/",
            mainEntityOfPage: {
              "@id": "https://alnjoom.sa/#webpage"
            },
            parentOrganization: {
              "@id": "https://alnjoom.sa/#organization"
            },
            description: "مكتب النجوم المميزة للاستقدام هو مكتب استقدام معتمد  في تبوك يقدم خدمات استقدام العمالة المنزلية من الفلبين وكينيا وإثيوبيا وبنجلاديش وباكستان وبوروندي لجميع مناطق المملكة العربية السعودية.",
            image: {
              "@type": "ImageObject",
              url: "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png"
            },
            telephone: "+966594003605",
            address: {
              "@type": "PostalAddress",
              streetAddress: "King Fahd Rd, Assulimaniyah",
              addressLocality: "Tabuk",
              addressRegion: "Tabuk",
              postalCode: "47312",
              addressCountry: "SA"
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 28.403638,
              longitude: 36.569611
            },
            hasMap: "https://maps.app.goo.gl/hJf3ho1R44bsZBd29",
            openingHoursSpecification: [{
              "@type": "OpeningHoursSpecification",
              dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
              opens: "09:00",
              closes: "12:00"
            }, {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
              opens: "16:00",
              closes: "22:00"
            }, {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: "Saturday",
              opens: "16:00",
              closes: "22:00"
            }],
            areaServed: {
              "@type": "Country",
              name: "Saudi Arabia"
            },
            priceRange: "SAR 3950-14499",
            currenciesAccepted: "SAR",
            paymentAccepted: ["Visa", "MasterCard", "Mada"],
            contactPoint: {
              "@id": "https://alnjoom.sa/#contact"
            },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.4",
              reviewCount: "247",
              bestRating: "5",
              worstRating: "1"
            },
            knowsAbout: ["استقدام العمالة المنزلية", "استقدام من الفلبين", "استقدام من كينيا", "استقدام من إثيوبيا", "استقدام من بنجلاديش", "استقدام من باكستان", "استقدام من بوروندي", "منصة مساند"]
          }, {
            "@type": "WebSite",
            "@id": "https://alnjoom.sa/#website",
            url: "https://alnjoom.sa/",
            name: "مكتب النجوم المميزة للاستقدام",
            publisher: {
              "@id": "https://alnjoom.sa/#organization"
            },
            inLanguage: ["ar-SA", "en-SA"]
          }, {
            "@type": "WebPage",
            "@id": "https://alnjoom.sa/#webpage",
            url: "https://alnjoom.sa/",
            name: "مكتب النجوم المميزة للاستقدام",
            isPartOf: {
              "@id": "https://alnjoom.sa/#website"
            },
            about: {
              "@id": "https://alnjoom.sa/#agency"
            },
            mainEntity: {
              "@id": "https://alnjoom.sa/#agency"
            },
            inLanguage: "ar-SA"
          }, {
            "@type": "Service",
            "@id": "https://alnjoom.sa/#service",
            name: " خدمات استقدام العمالة المنزلية في تبوك",
            serviceType: "استقدام العمالة المنزلية",
            provider: {
              "@id": "https://alnjoom.sa/#agency"
            },
            areaServed: {
              "@type": "Country",
              name: "Saudi Arabia"
            }
          }]
        })
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeroSection, {
      heroData: heroData,
      siteInfo: siteInfo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(About, {
      siteInfo: siteInfo,
      data: aboutData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Home_RequirementsSection, {
      siteInfo: siteInfo,
      data: requirementsData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Systems, {
      siteInfo: siteInfo,
      data: systemsData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Countries/* default */.Z, {
      data: countriesData,
      personnel: personnelsData
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "contact-page ".concat((contact_module_default()).contact),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "contact-header unique-bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "communicate"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "contact-page-top wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "contact-row-wrapper p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
              className: "contact-row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: "12",
                md: "6",
                className: "align-self-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default */.Z, {
                  formTitle: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "service_question"
                  }),
                  formSubtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "service_ask"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: "12",
                md: "6",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "contact-page-map",
                  "data-aos": "fade-up",
                  "data-aos-duration": "300",
                  "data-aos-delay": "400",
                  dangerouslySetInnerHTML: {
                    __html: (_initData$siteInfo$ma = initData === null || initData === void 0 ? void 0 : (_initData$siteInfo = initData.siteInfo) === null || _initData$siteInfo === void 0 ? void 0 : _initData$siteInfo.mapframe) !== null && _initData$siteInfo$ma !== void 0 ? _initData$siteInfo$ma : ""
                  }
                })
              })]
            })
          })
        })
      })]
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var pages = (Index);

/***/ }),

/***/ 5424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Countries; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1555);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2615);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _handlers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9400);
/* harmony import */ var _helpers_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7819);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);









function Countries(_ref) {
  var _data$items;

  var data = _ref.data,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? "" : _ref$page;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      locale = _useRouter.locale;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().partners), " wrapper ").concat(page, " w-100"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      className: "w-100 m-0",
      children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(function (item, index) {
        var _item$name;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          xxl: 2,
          lg: 3,
          md: 4,
          sm: 6,
          xs: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "item",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: "/recruitmentCountries/".concat((0,_helpers_functions__WEBPACK_IMPORTED_MODULE_3__/* .getId */ .zv)(item)),
              legacyBehavior: true,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {})
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
              src: (0,_handlers__WEBPACK_IMPORTED_MODULE_2__/* .handleImage */ .M)(item === null || item === void 0 ? void 0 : item.image),
              height: 71,
              width: 71,
              alt: ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name[locale]
            })]
          })
        }, "country" + index);
      })
    })
  });
}

/***/ }),

/***/ 472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7536);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4012);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1555);
/* harmony import */ var _src_assets_images_svg_arrow_big_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9492);
/* harmony import */ var _src_api_server__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5981);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6455);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var Form = function Form() {
  var _errors$Name, _errors$phone, _errors$email;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      systems = _useState[0],
      setSystems = _useState[1];

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      errors = _useForm.formState.errors;

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      var systemsResponse, sectionData;
      return _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _src_api_server__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("/pages/systems");

            case 2:
              systemsResponse = _context.sent;

              sectionData = function sectionData(r) {
                var _r$data, _r$data$data, _r$data$data$page;

                return (r === null || r === void 0 ? void 0 : (_r$data = r.data) === null || _r$data === void 0 ? void 0 : (_r$data$data = _r$data.data) === null || _r$data$data === void 0 ? void 0 : (_r$data$data$page = _r$data$data.page) === null || _r$data$data$page === void 0 ? void 0 : _r$data$data$page.sections) || [];
              };

              setSystems(sectionData(systemsResponse));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(data) {
      return _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _src_api_server__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .Z.post("/pages/contact/sections", {
                section: _objectSpread(_objectSpread({}, data), {}, {
                  title: data.name
                })
              });

            case 3:
              reset();
              sweetalert2__WEBPACK_IMPORTED_MODULE_6___default().fire("".concat(formatMessage({
                id: "thanks"
              })), "".concat(formatMessage({
                id: "thankMsg"
              })), "success");
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return");

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "order-form",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            className: "p-0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              className: "form-group",
              "data-aos": "fade-up",
              "data-aos-duration": "300",
              "data-aos-delay": "100",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
                htmlFor: "name",
                children: formatMessage({
                  id: "name"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread({
                id: "name",
                className: "form-control border"
              }, register("name", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$Name = errors.Name) === null || _errors$Name === void 0 ? void 0 : _errors$Name.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                  id: "requiredFields"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              className: "form-group",
              "data-aos": "fade-up",
              "data-aos-duration": "300",
              "data-aos-delay": "200",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
                htmlFor: "phone",
                children: formatMessage({
                  id: "phone"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread({
                id: "phone",
                type: "text",
                className: "form-control border"
              }, register("phone", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                  id: "requiredFields"
                })
              })]
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            className: "p-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              className: "form-group",
              "data-aos": "fade-up",
              "data-aos-duration": "300",
              "data-aos-delay": "400",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
                htmlFor: "message",
                children: formatMessage({
                  id: "details"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("textarea", _objectSpread({
                id: "message",
                className: "form-control border"
              }, register("message", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                  id: "requiredFields"
                })
              })]
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: "form-group button",
          "data-aos": "fade-up",
          "data-aos-duration": "300",
          "data-aos-delay": "500",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
            type: "submit",
            className: "btn gradient-btn",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              id: "send"
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Form);

/***/ }),

/***/ 6543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Seo = function Seo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$noindex = _ref.noindex,
      noindex = _ref$noindex === void 0 ? false : _ref$noindex;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      asPath = _useRouter.asPath,
      locale = _useRouter.locale;

  var _buildSeoAlternates = (0,_src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__/* .buildSeoAlternates */ .Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    defaultTitle: title,
    noindex: noindex,
    nofollow: noindex,
    canonical: canonical,
    languageAlternates: languageAlternates,
    additionalMetaTags: [{
      name: "keywords",
      content: keywords
    }]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Seo);

/***/ }),

/***/ 9400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ handleImage; }
});

;// CONCATENATED MODULE: ./src/assets/images/placeholder.jpg
/* harmony default export */ var placeholder = ({"src":"/_next/static/media/placeholder.75cf2fc2.jpg","height":319,"width":474,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsgP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/handlers/index.js

var handleImage = function handleImage(image) {
  var _ref;

  if ((_ref = "".concat(image)) !== null && _ref !== void 0 && _ref.includes("http")) return image;

  if (image) {
    if (!image.startsWith("/")) image = "/".concat(image);
    return "".concat("https://alnojoom.ejjadh.info/").concat(image);
  }

  return image || (placeholder === null || placeholder === void 0 ? void 0 : placeholder.src);
};

/***/ }),

/***/ 7819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ handleImageLink; },
/* harmony export */   "SI": function() { return /* binding */ htmlToExcerpt; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports mapBlogForListing, checkRedirect */
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);



var getId = function getId(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj._id) || (obj === null || obj === void 0 ? void 0 : obj.id) || "".concat(obj);
}; // يبني مُقتطف نصي قصير من HTML كامل (يحذف الصور base64 والوسوم) لتفادي تضخيم حجم الصفحة

var htmlToExcerpt = function htmlToExcerpt(html) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  if (!html) return "";
  var withoutImages = String(html).replace(/<img[^>]*>/gi, "");
  var text = withoutImages.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return text.length > maxLength ? "".concat(text.slice(0, maxLength).trim(), "\u2026") : text;
}; // يحوّل قيمة مترجمة (ar/en) تحتوي HTML كامل إلى نفس الشكل لكن بمقتطف نصي قصير

var localizedExcerpt = function localizedExcerpt(localized, maxLength) {
  if (!localized || typeof localized !== "object") return localized;
  return Object.fromEntries(Object.entries(localized).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        locale = _ref2[0],
        html = _ref2[1];

    return [locale, htmlToExcerpt(html, maxLength)];
  }));
}; // يبني نسخة خفيفة من كائن المدونة لصفحات القوائم، بدون وصف HTML الكامل
// (الذي قد يحتوي صورًا مرفوعة كـ base64 ويُضاعف حجم الصفحة عند تسلسله ضمن __NEXT_DATA__)


var mapBlogForListing = function mapBlogForListing(blog) {
  var _blog$category, _blog$category2, _blog$category3;

  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return {
    id: (blog === null || blog === void 0 ? void 0 : blog.id) || (blog === null || blog === void 0 ? void 0 : blog._id) || null,
    title: blog === null || blog === void 0 ? void 0 : blog.title,
    image: blog === null || blog === void 0 ? void 0 : blog.image,
    category: blog !== null && blog !== void 0 && blog.category ? {
      id: (blog === null || blog === void 0 ? void 0 : (_blog$category = blog.category) === null || _blog$category === void 0 ? void 0 : _blog$category.id) || (blog === null || blog === void 0 ? void 0 : (_blog$category2 = blog.category) === null || _blog$category2 === void 0 ? void 0 : _blog$category2._id) || null,
      title: (blog === null || blog === void 0 ? void 0 : (_blog$category3 = blog.category) === null || _blog$category3 === void 0 ? void 0 : _blog$category3.title) || null
    } : null,
    createdAt: blog === null || blog === void 0 ? void 0 : blog.createdAt,
    description: localizedExcerpt(blog === null || blog === void 0 ? void 0 : blog.description, maxLength)
  };
};
var handleImageLink = function handleImageLink(image) {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    return "".concat("https://alnojoom.ejjadh.info/", "/").concat(image);
  }
}; // ضع هذا الكود داخل نفس ملف الصفحة

var REDIRECTS_ENDPOINT = "https://alnojoom.ejjadh.info/api/seoRedirects"; // نظّف المسار: فك التشفير + إزالة ?query + إزالة / آخر المسار

function cleanPath() {
  var resolvedUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  try {
    var noQuery = String(resolvedUrl).split("?")[0] || "/";
    var decoded = decodeURI(noQuery);
    return decoded.length > 1 && decoded.endsWith("/") ? decoded.slice(0, -1) : decoded;
  } catch (_unused) {
    var _noQuery = String(resolvedUrl).split("?")[0] || "/";

    return _noQuery.length > 1 && _noQuery.endsWith("/") ? _noQuery.slice(0, -1) : _noQuery;
  }
} // ابنِ Destination مطلق بدون أي Query Params


function toAbsoluteNoQuery(destRaw, req) {
  try {
    if (/^https?:\/\//i.test(destRaw)) {
      var u = new URL(destRaw);
      u.search = "";
      return u.toString();
    }

    var protocol = (req.headers["x-forwarded-proto"] || "").split(",")[0] || (req.socket && req.socket.encrypted ? "https" : "http");
    var host = req.headers.host;
    var path = destRaw.startsWith("/") ? destRaw : "/".concat(destRaw);
    return "".concat(protocol, "://").concat(host).concat(path);
  } catch (_unused2) {
    return String(destRaw).split("?")[0];
  }
}

function checkRedirect(_x, _x2) {
  return _checkRedirect.apply(this, arguments);
}

function _checkRedirect() {
  _checkRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolvedUrl, req) {
    var path, res, json, redirects, hit, permanent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = cleanPath(resolvedUrl);
            _context.prev = 1;
            _context.next = 4;
            return fetch(REDIRECTS_ENDPOINT, {
              headers: {
                Accept: "application/json"
              }
            });

          case 4:
            res = _context.sent;

            if (res.ok) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", null);

          case 7:
            _context.next = 9;
            return res.json();

          case 9:
            json = _context.sent;
            redirects = json && json.data && json.data.seoRedirects || [];
            hit = redirects.find(function (r) {
              return (r === null || r === void 0 ? void 0 : r.source) && (r === null || r === void 0 ? void 0 : r.destination) && cleanPath(r.source) === path;
            });

            if (hit) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", null);

          case 14:
            permanent = String(hit.redirectCode) === "301" || String(hit.redirectCode) === "308";
            return _context.abrupt("return", {
              destination: toAbsoluteNoQuery(String(hit.destination).trim(), req),
              permanent: permanent
            });

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", null);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _checkRedirect.apply(this, arguments);
}

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8929);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9492:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-big.e723219e.svg","height":16,"width":18});

/***/ }),

/***/ 2615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"partners":"Countries_partners__zKNov","gradient_in":"Countries_gradient_in__iWN_E","gradient_out":"Countries_gradient_out__e5rJQ","gradient_opacity_out":"Countries_gradient_opacity_out__pKqTE","gradient_opacity_in":"Countries_gradient_opacity_in__TWQ6e"};

/***/ }),

/***/ 6323:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hero":"style_hero__A_Z22"};

/***/ }),

/***/ 901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"requirements":"style_requirements__nPFoQ"};

/***/ }),

/***/ 7601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"systems":"Systems_systems__USQMy","grid_container":"Systems_grid_container__s_bxQ","service":"Systems_service__kJPoc","btn":"Systems_btn__Sbxfn","gradient_in":"Systems_gradient_in__KPlUk","gradient_out":"Systems_gradient_out__FBfxi","gradient_opacity_out":"Systems_gradient_opacity_out__BfKbP","gradient_opacity_in":"Systems_gradient_opacity_in__w_APM"};

/***/ }),

/***/ 451:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact___aHw6","gradient_in":"contact_gradient_in__hWSdp","gradient_out":"contact_gradient_out__OA75o","gradient_opacity_out":"contact_gradient_opacity_out___ZqSU","gradient_opacity_in":"contact_gradient_opacity_in__JKerv"};

/***/ }),

/***/ 735:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ buildWhatsAppUrl; }
/* harmony export */ });
/* unused harmony export WHATSAPP_MESSAGE */
var WHATSAPP_MESSAGE = "السلام عليكم ورحمة الله و بركاتة، وصلت إليكم من خلال موقع النجوم المميزة للاستقدام، وأرغب في الاستفسار عن خدمات الاستقدام والعروض المتاحة.";
var buildWhatsAppUrl = function buildWhatsAppUrl(phone) {
  return "https://wa.me/".concat(phone !== null && phone !== void 0 ? phone : "", "?text=").concat(encodeURIComponent(WHATSAPP_MESSAGE));
};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8166,2962,2143,1664,3053,5836,9774,2888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);